import React from "react";
import { MdEdit, MdDelete, MdToggleOn, MdToggleOff } from "react-icons/md";

export default function TableActionButtons({
    canEdit,
    canDelete,
    canToggle,
    onEdit,
    onDelete,
    onToggle,
    toggleStatus,
}) {
    return (
        <div className="flex items-center gap-3">
            {canEdit && (
                <button
                    onClick={onEdit}
                    className="cursor-pointer p-1 rounded-md"
                    style={{
                        background: 'var(--color-primary)',
                        color: 'var(--color-text, #fff)',
                        transition: 'background 0.2s',
                    }}
                    onMouseOver={e => e.currentTarget.style.background = 'var(--color-active)'}
                    onMouseOut={e => e.currentTarget.style.background = 'var(--color-primary)'}
                    title="Edit"
                >
                    <MdEdit size={14} color="#fff" />
                </button>
            )}
            {canToggle && (
                <button onClick={onToggle} title="Toggle Status" className="transition">
                    {toggleStatus === "ACTIVE" ? (
                        <MdToggleOn size={30} className="text-green-500" />
                    ) : (
                        <MdToggleOff size={30} className="text-gray-400" />
                    )}
                </button>
            )}
            {canDelete && (
                <button
                    onClick={onDelete}
                    className="text-red-500 hover:text-red-700"
                    title="Delete"
                >
                    <MdDelete size={18} />
                </button>
            )}
        </div>
    );
}